 <button class="btn btn-outline-primary" (click)="addtR()">{{ step3.add  | translate }}</button>
<div *ngFor="let obj of tabCarLibre?.tr; let i = index">
    <button class="btn btn-outline-primary" (click)="removetR(i)">{{ step3.remove  | translate }}</button>
    <app-tR [uid]="getUid()+'_index_'+(i+1)" [parentForm]="parentForm"
[disabled]="disabled"
 [tR]="obj" [labelTD]="step3.gettdlibre"></app-tR>
</div>
